const config = {
    apiUrl: 'https://mydarwinapp.com/api'
    //apiUrl: 'https://localhost:7115/api',
    //apiAuthUrl:'https://localhost:5051/auth/api'
    //apiAuthUrl:'https://dudewithanapp.site/auth/api'
  };
  
  export default config;